import { useQuery } from '@apollo/client';
import { QualitativeFactor } from '../pages/cyber';
import { GET_QUALITATIVE_FACTOR } from '../pages/dataInputs/data-inputs/qualitative-factors/queries';

type QualitativeFactorData = {
  getQualitativeFactor: QualitativeFactor;
};

/**
 * Hook to fetch the qualitative factor name for a given qualitative factor ID
 * @param qualitativeFactorId - The ID of the qualitative factor to fetch the name for
 * @returns An object containing the qualitative factor name and a boolean indicating if the qualitative factor is loading
 */
export const useQualitativeFactorName = (
  qualitativeFactorId: string | undefined,
) => {
  const {
    data: qualitativeFactorData,
    loading: isQualitativeFactorLoading,
    error: qualitativeFactorError,
  } = useQuery<QualitativeFactorData>(GET_QUALITATIVE_FACTOR, {
    variables: {
      uuid: qualitativeFactorId,
    },
  });

  return {
    qualitativeFactorName: qualitativeFactorData?.getQualitativeFactor.name,
    isQualitativeFactorLoading,
    qualitativeFactorError,
  };
};
